<div odxLayout="grid" [formGroupName]="groupName">
  <span odxLayout="10 4@desktop 5@tablet" class="odx-text">{{ label }}</span>
  <odx-switch
    odxLayout="2 1@tablet"
    formControlName="checked"
    [readonly]="(isReadOnlyUser$ | async) === true || (hasWritePermission$ | async) === false"
  >
  </odx-switch>

  <div odxLayout="12 5@desktop 6@tablet">
    @if (subLabel) {
      <p [class.text-disabled]="disabled">{{ subLabel }}</p>
    }

    <div formArrayName="choices" class="choices-container">
      @for (option of options; track option.value) {
        <odx-checkbox [formControlName]="option.value">{{ option.label }}</odx-checkbox>
      }
    </div>

    @if (!disabled && networkOptionsVisible) {
      <p>Network configuration</p>

      <odx-radio-group
        formControlName="networkChoice"
        [horizontal]="!isPhone()"
        [readonly]="(isReadOnlyUser$ | async) === true || (hasWritePermission$ | async) === false"
        class="group"
      >
        @for (option of networkOptions; track option.value) {
          <odx-radio-button [value]="option.value">{{ option.label }}</odx-radio-button>
        }
      </odx-radio-group>
    }

    @if (!disabled && connectionToOptionsVisible) {
      <p>What is the secondary display connected to?</p>

      <odx-radio-group
        formControlName="connectionToChoice"
        [horizontal]="!isPhone()"
        [readonly]="(isReadOnlyUser$ | async) === true || (hasWritePermission$ | async) === false"
        class="group"
      >
        @for (option of connectionToOptions; track option.value) {
          <odx-radio-button [value]="option.value">{{ option.label }}</odx-radio-button>
        }
      </odx-radio-group>
    }

    <odx-form-field [readonly]="(isReadOnlyUser$ | async) === true || (hasWritePermission$ | async) === false || disabled">
      <textarea formControlName="notes" odxFormFieldControl [placeholder]="notesPlaceholder"></textarea>
    </odx-form-field>
  </div>
</div>
